import moment from 'moment'
import timelogApi from '@/store/api/timelog'

const actions = {
  loadTimelog({commit}, {start_date, end_date}) {
    var startD = moment(start_date).format('YYYY-MM-DD')
    var endD = moment(end_date).format('YYYY-MM-DD')
    if (startD && endD) {
      return timelogApi.getTimelogs(startD, endD).then(logs => {
        return Promise.resolve(logs)
      }).catch(err => {
        console.error('an error occurred while loading timelogs', err)
        return Promise.resolve([])
      })
    } else {
      return Promise.resolve([])
    }
  },

  addTimelog({commit}, {person_id, task_id, start_time, end_time, day}) {
    return timelogApi.addTimelog(person_id, task_id, start_time, end_time, day).then(rsp => {
      return Promise.resolve(['uwu'])
    }).catch(err => {
      console.error('an error occured while adding a timelog', err)
      return Promise.resolve([])
    })
  }
}

export default {
  actions
}
